import React, { ReactNode } from 'react';
import { isFunction } from 'lodash';

import {
  Dropdown as DSDropdown,
  FormLabel,
  Spacer,
  Text,
} from '@zapier/design-system';

export type DropdownField = {
  /** Additional content to describe this field. */
  details?: ReactNode;
  /** The unique ID of this field. */
  id: string;
  /** Is this field required? */
  isRequired?: boolean;
  /** The label that describes this field. */
  label: string;
  /** Identifies this field type. */
  type: 'dropdown';
  /** Items to display in the dropdown. */
  items: {
    label: string;
    value: string;
  }[];
};

export type DropdownProps = {
  /** The callback function to fire when the field changes. */
  onChange: (value: string) => void;
  /** Static properties about this field. */
  staticProperties: DropdownField;
  /** A prefilled value from some higher state. */
  value?: string;
};

/**
 * A dropdown form field.
 */
const Dropdown = ({
  onChange,
  staticProperties: { details, id, items, isRequired, label },
  value,
}: DropdownProps) => {
  return (
    <div>
      <FormLabel htmlFor={id} isRequired={isRequired}>
        {label}
      </FormLabel>
      {!details && <Spacer height={5} />}
      {details && (
        <Text margin="10px 0">{isFunction(details) ? details() : details}</Text>
      )}
      <DSDropdown
        aria-required={isRequired}
        id={id}
        initialSelectedItem={items.find(item => item.value === value)}
        items={items}
        menuAriaLabel=""
        onChange={(item: { value: string }) => onChange(item.value)}
      />
    </div>
  );
};

export default Dropdown;
